import { BufferBag, OrderProduct, OrderProductType, ProductType } from '../pages/types';

export type BufferBagSelectionKey = `${string}~${string}`; // pet_plan_id~recipe_id format

export interface PetPlanBufferBagTotals {
  totalDays: number;
  totalCost: number;
}

export const generateFormattedBufferOptions = (extraDays: number, numberOfBags: number) => {
  const options = [];
  for (let numBags = 0; numBags <= numberOfBags; numBags++) {
    options.push({
      value: numBags.toString(),
      label: (numBags * extraDays).toString(),
    });
  }
  return options;
};

export const prepareBufferBagProducts = (
  selectedBufferBags: Record<string, number>,
  bufferBagList?: BufferBag[],
  isFreeProducts?: boolean
): { product_code: string; quantity: number; pet_plan: string }[] => {
  if (!bufferBagList) return [];

  const productUpdatePayload: {
    product_code: string;
    quantity: number;
    pet_plan: string;
    type: OrderProductType;
  }[] = [];

  Object.entries(selectedBufferBags).forEach(([dogFood, numberOfBags]) => {
    const [dogPetPlanId, bufferBagProductCode] = dogFood.split('~');
    const product = bufferBagList
      .find((pet) => pet.pet_plan_id === dogPetPlanId)
      ?.buffer_bag_products?.find((prod) => prod.buffer_bag_product_code === bufferBagProductCode);

    if (product) {
      productUpdatePayload.push({
        product_code: isFreeProducts
          ? product.buffer_bag_product_code + '-FREE'
          : product.buffer_bag_product_code,
        quantity: numberOfBags,
        pet_plan: dogPetPlanId,
        type: OrderProductType.ONETIME,
      });
    }
  });
  return productUpdatePayload;
};

export const calculateTotalsPerDog = (
  petPlanId: string,
  bufferBagList: BufferBag[],
  selectedBufferBags: Record<string, number>
): PetPlanBufferBagTotals => {
  let totalDays = 0;
  let totalCost = 0;

  const bufferBagInfo = bufferBagList?.find(
    (buffer_bag_info) => buffer_bag_info.pet_plan_id === petPlanId
  );
  const numberOfDaysPerBag = bufferBagInfo?.buffer_bag_extra_days || 0;
  const products = bufferBagInfo?.buffer_bag_products;
  Object.entries(selectedBufferBags).forEach(([petPlanRecipe, numberOfBags]) => {
    const [dogPetPlanId, bufferBagProductCode] = petPlanRecipe.split('~');
    if (dogPetPlanId === petPlanId) {
      const product = products?.find(
        (prod) => prod.buffer_bag_product_code === bufferBagProductCode
      );
      if (product) {
        const pricePerBag = Number(product.buffer_bag_price) || 0;
        totalDays += numberOfBags * numberOfDaysPerBag;
        totalCost += numberOfBags * pricePerBag;
      }
    }
  });
  return { totalDays, totalCost };
};

export const petPlanHasBufferBags = (products: OrderProduct[], petPlanId: string) => {
  return products.some(
    (product) => product.pet_plan?.id === petPlanId && product.product_type === ProductType.BUFFER
  );
};
